import { render } from "./MiniSettings.vue?vue&type=template&id=10e57764"
import script from "./MiniSettings.vue?vue&type=script&lang=js"
export * from "./MiniSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__